import React from 'react';

const Footer = () => {
  return (
    <footer className="py-6 bg-ui-light-background dark:bg-ui-dark-background border-t border-ui-light-border dark:border-ui-dark-border transition-colors relative z-0">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between space-y-4 md:flex-row md:space-y-0">
          <div className="flex items-center space-x-2">
            <img 
              src="https://escola.cbpf.br/logos/cbpf-logo.png" 
              alt="CBPF Logo" 
              className="h-8 w-auto object-contain invert dark:invert-0 z-0"
            />
            <span className="text-sm font-medium text-ui-light-text-secondary dark:text-ui-dark-text-tertiary">
              SCoPE-AI
            </span>
          </div>
          
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-ui-light-text-tertiary dark:text-ui-dark-text-tertiary">
            <a 
              href="https://www.gov.br/cbpf/pt-br" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              CBPF Official
            </a>
            <a 
              href="https://escola.cbpf.br" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
            >
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
              </svg>
              CBPF School
            </a>
          </div>
        </div>
        
        <div className="mt-4 pt-4 border-t border-ui-light-border dark:border-ui-dark-border">
          <p className="text-xs text-center text-ui-light-text-muted dark:text-ui-dark-text-muted">
            &copy; {new Date().getFullYear()} Astronomy Data Smart System. All rights reserved.
          </p>
          <p className="mt-2 text-xs text-center text-ui-light-text-muted dark:text-ui-dark-text-muted">
            Developed by <a 
              href="https://github.com/schwarzam" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
            >
              schwarzam
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;